// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/header/HeaderComp.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/header/HeaderComp.tsx");
  import.meta.hot.lastModified = "1724846695000";
}
// REMIX HMR END

import { NavLink, useParams } from "@remix-run/react";
import MainNavigationMenu from "./NavMenu";
import { createLangPathByParam } from "~/utils/lang";
export default function HeaderComp() {
  _s();
  const {
    lang
  } = useParams();
  return <header className="hdr_fr">
            <div className="hdr_in">
                <NavLink to={createLangPathByParam(lang, '/')} className="logo as_link">
                    ZH
                </NavLink>
                <MainNavigationMenu />
            </div>
        </header>;
}
_s(HeaderComp, "VhfNE0ijDGZiZT83Cb9rsFz6I8k=", false, function () {
  return [useParams];
});
_c = HeaderComp;
var _c;
$RefreshReg$(_c, "HeaderComp");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;